import useTranslateMessage from './useTranslateMessage'
import { useRouter } from 'next/router'

interface SitemapMetaProps {
  sitemapType: string
  keyword?: string
}

const host = process.env.NEXT_PUBLIC_HOST

const useSitemapMeta = ({ sitemapType, keyword }: SitemapMetaProps) => {
  const translate = useTranslateMessage()
  const { asPath, locale } = useRouter()

  const canonicalUrl = `${host}/${locale}${asPath}`

  return {
    title: translate('htmlSitemap.meta.title', {
      type: keyword || translate(`htmlSitemap.type.${sitemapType}`)
    }),
    description: translate('htmlSitemap.meta.description', {
      type: keyword || translate(`htmlSitemap.type.${sitemapType}`)
    }),
    canonicalUrl
  }
}

export default useSitemapMeta
